export default __webpack_public_path__ + "static/media/ec-w.75d5f50a.svg";